import { graphql, HttpResponse } from 'msw'
import { type HistoricalStockPrices } from '../../models/chat/chat'

export const historicalStockPricesMock: HistoricalStockPrices = {
  __typename: 'HistoricalStockPrices',
  ticker: 'AAPL',
  exchange: 'NASDAQ',
  name: 'Apple Inc.',
  prices: [
    {
      date: '2022-01-03',
      openPrice: 177.83,
      highPrice: 182.88,
      lowPrice: 177.71,
      closePrice: 182.01,
      volume: 104487900,
    },
    {
      date: '2022-01-04',
      openPrice: 182.63,
      highPrice: 182.94,
      lowPrice: 179.12,
      closePrice: 179.7,
      volume: 99310400,
    },
    {
      date: '2022-01-05',
      openPrice: 179.61,
      highPrice: 180.17,
      lowPrice: 174.64,
      closePrice: 174.92,
      volume: 94537600,
    },
  ],
}

export const mockGetHistoricalStockPricesHandler = graphql.query('historicalStockPrices', () => {
  return HttpResponse.json({ data: { historicalStockPrices: historicalStockPricesMock } })
})

export const mockHistoricalStockPrices = [mockGetHistoricalStockPricesHandler]
